import api from '../../../core/api/api';

export const dashboardService = {
  getUltimasFacturaciones: async (usuario) => {
    const response = await api.post('/Dashboard/UltimasFacturacionesTecnico', { usuario });
    return response.data;
  }
};

export default dashboardService;
